import React, { useEffect } from "react";
import "./style.scss";
import SingleNews from "./single-news";
import useNews from "./hooks/useNews";
import { useTranslation } from "react-i18next";
import useFacility from "../../../utils/hooks/useFacility";

const NewsPage: React.FC = () => {
  const { acceptTransaction, news } = useNews();
  const { t } = useTranslation();
  const facilityIds = useFacility();

  
  useEffect(() => {
    setTimeout(() => {
      acceptTransaction();
    }, 200);
  }, [facilityIds]);



  return (
    <div>
      <div className="headline">
        <h1>{t("aktualnosci")}</h1>
        <div className="line"></div>
      </div>
      {news.length > 0 ? (
        <div className="news-wrapper flex-start flex-wrap">
          {news.map((item, index) => (
            <SingleNews item={item} key={index} />
          ))}
        </div>
      ) : (
        <div className="alert alert-yellow">
          <b>{t("brak_aktywnych_aktualnosci")}</b>
        </div>
      )}
    </div>
  );
};

export default NewsPage;
